import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slider--wrapper" }
const _hoisted_2 = { class: "slider--container" }
const _hoisted_3 = { class: "input--wrapper" }
const _hoisted_4 = { class: "input--label" }
const _hoisted_5 = {
  key: 0,
  class: "input-prefix"
}
const _hoisted_6 = { class: "input--wrapper" }
const _hoisted_7 = { class: "input--label" }
const _hoisted_8 = {
  key: 0,
  class: "input-prefix"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Slider"], {
      class: "slider",
      modelValue: $props.modelValue,
      tooltips: false,
      lazy: false,
      min: $props.minValue,
      max: $props.maxValue,
      step: $props.step,
      onChange: $setup.changeSliderValue
    }, null, 8, ["modelValue", "min", "max", "step"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString($props.minTitle), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["input--container", `position-${$props.position}`])
        }, [
          _createVNode($setup["Cleave"], {
            class: "input input-default",
            modelValue: $props.modelValue[0],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.modelValue[0]) = $event)),
            onChange: $setup.changeStart,
            options: $setup.optionNumeric
          }, null, 8, ["modelValue"]),
          ($props.units)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.units), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "slider--delimiter" }, "-", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString($props.maxTitle), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["input--container", `position-${$props.position}`])
        }, [
          _createVNode($setup["Cleave"], {
            class: "input input-default",
            modelValue: $props.modelValue[1],
            onChange: $setup.changeEnd,
            options: $setup.optionNumeric
          }, null, 8, ["modelValue"]),
          ($props.units)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.units), 1))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}